import { render, staticRenderFns } from "./dialog-change-topic.vue?vue&type=template&id=f7b3a886&scoped=true&"
import script from "./dialog-change-topic.vue?vue&type=script&lang=js&"
export * from "./dialog-change-topic.vue?vue&type=script&lang=js&"
import style0 from "./dialog-change-topic.vue?vue&type=style&index=0&id=f7b3a886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b3a886",
  null
  
)

export default component.exports